import { LinkButton as LinkButtonLeshenUI } from '@leshen/ui'
import React from 'react'
import { useMapi } from '../context/MapiProvider'
import { usePhoneAvailability } from '../context/PhoneAvailabilityProvider'
import { useUser } from '../context/UserProvider'

const LinkButton = ({
  children,
  to = '',
  CustomLink = null,
  mobileText = null,
  cobra = null,
  ...props
}) => {
  const isPhoneAvailable = usePhoneAvailability()
  const { sessionPromoCode, requestId, rotatedNumber } = useMapi()

  const { userLocation } = useUser() || {}
  const rotatedNumberWithoutDash = rotatedNumber?.replaceAll('-', '')
  const hideCobra =
    (cobra === 'hide after hours' && !isPhoneAvailable) ||
    (cobra === 'hide during hours' && isPhoneAvailable)

  const linkTo = to
    ?.replace('{PROMO_CODE}', sessionPromoCode)
    ?.replace('{REQUEST_ID}', requestId)
    ?.replace('{ROTATING_NUMBER}', rotatedNumberWithoutDash)
    ?.replace('{USER_ZIP_CODE}', userLocation?.zipCode)
    ?.replace(
      '{USER_CITY}',
      userLocation?.city?.toLowerCase()?.replace(' ', '-')
    )
    ?.replace(
      '{USER_STATE}',
      userLocation?.state?.fullName?.toLowerCase()?.replace(' ', '-')
    )

  return (
    <LinkButtonLeshenUI
      customClasses="convert-link-button"
      to={linkTo}
      CustomLink={CustomLink}
      requestId={requestId}
      mobileText={mobileText}
      isPhoneAvailable={isPhoneAvailable}
      hideCobra={hideCobra}
      {...props}
    >
      {children}
    </LinkButtonLeshenUI>
  )
}

export default LinkButton
